import { AttachmentFile } from "@inrev/common";
import { FC, useCallback } from "react";
import { type AttachmentContext, trackAttachmentAction } from "../../analytics";
import { useGetFilesAsZip } from "../../api";
import { ClickableIcon } from "../primitives";
import { Spinner } from "../ui/Spinner";

export type DownloadConfig = {
	baseUrl: string;
	queryKeyPrefix: string;
	fileName?: string;
};

type DownloadAllAttachmentsProps = {
	downloadConfig: DownloadConfig;
	allUploadedRows: AttachmentFile[];
	analyticsContext: AttachmentContext;
};
export const DownloadAllAttachments: FC<DownloadAllAttachmentsProps> = ({
	downloadConfig,
	allUploadedRows,
	analyticsContext,
}) => {
	const { getFilesAsZip, filesAsZipLoading } = useGetFilesAsZip();

	const handleDownloadAll = useCallback(() => {
		const files = allUploadedRows.map((row) => ({
			fileName: row.file.name,
			extension: row.file.extension,
			url: `${downloadConfig.baseUrl}/${row.id}`,
		}));
		if (files.length === 0) return;
		trackAttachmentAction("download_all", analyticsContext);
		getFilesAsZip({
			files,
			queryKey: [`${downloadConfig.queryKeyPrefix}-all`],
			zippedFileName: downloadConfig.fileName ?? "Attachments",
		});
	}, [downloadConfig, allUploadedRows, getFilesAsZip, analyticsContext]);

	return filesAsZipLoading ? (
		<Spinner spinnerClassName="h-[19px] w-[19px]" containerClassName="h-[19px] w-fit" />
	) : (
		<ClickableIcon
			onClick={handleDownloadAll}
			type="arrow-down-tray"
			size="small"
			color="secondary"
			trackingId={`${analyticsContext}-attachments-download-all`}
		/>
	);
};
